import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoModule } from '@ngneat/transloco';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { LibSharedCommonModule } from 'projects/lib-shared-common/src/public-api';
import { SvcSmartUserAvatarComponent } from './svc-smart-user-avatar.component';
import { SvcDialogsModule } from '@solvace/component/svc-dialogs';
import { SvcUserAvatarModule } from '@solvace/component/svc-user-avatar';

@NgModule({
  declarations: [
    SvcSmartUserAvatarComponent,
  ],
  imports: [
    LibSharedCommonModule,
    MatIconModule,
    MatTooltipModule,
    SvcDialogsModule,
    SvcUserAvatarModule,
    TranslocoModule,
    NgxSkeletonLoaderModule,
  ],
  exports: [
    SvcSmartUserAvatarComponent,
  ],
})
export class SvcSmartUserAvatarModule { }
